import { OPERATOR_DETAIL_ROUTE, SUBSCRIPTIONS_PATH } from './utils/navigation';

export { default as SubscriptionInsightsDashboard } from './pages/Dashboard';
export { default as SubscriptionInsightsOperatorDetail } from './pages/OperatorDetail';

export const subscriptionInsightsModule = {
    path: SUBSCRIPTIONS_PATH,
    detailPath: OPERATOR_DETAIL_ROUTE,
    menuKey: 'subscriptions',
    menuLabel: 'Suscripciones',
};
